import { useEffect, useState } from 'react';
import { getAnalyticsPolicy } from '../../../services/analyticsPolicy';
import { resolveEditCapability } from '../../../constants/analyticsConstants';

/**
 * Что текущий пользователь может делать с правилами и зонами камеры
 * (Part 4, разделы 6.9 и 7.1).
 *
 * Политика лежит на admin-роуте, поэтому клиент её прочитать, скорее всего,
 * не сможет. Нечитаемая политика не означает «ничего нельзя»: по зонам
 * клиенту остаётся режим предложения — заявка реально сохраняется в C3, а
 * решение принимает администратор.
 *
 * Правила — отдельный случай: C3 Change Requests поддерживает только
 * zone_* и policy_*, заявку на правило сохранить негде. Поэтому клиенту
 * правила недоступны в любом режиме: показать действие, которое нельзя
 * сохранить, хуже, чем не показать его вовсе.
 */
export const useAnalyticsCapability = (cameraId, { isAdmin }) => {
  const [capability, setCapability] = useState({ rules: 'none', zones: 'none' });
  const [policy, setPolicy] = useState(null);

  useEffect(() => {
    if (!cameraId) {
      setCapability({ rules: 'none', zones: 'none' });
      setPolicy(null);
      return undefined;
    }

    if (isAdmin) {
      setCapability({ rules: 'direct', zones: 'direct' });
      return undefined;
    }

    let cancelled = false;

    getAnalyticsPolicy(cameraId)
      .then((data) => {
        if (cancelled) return;
        setPolicy(data);
        setCapability({
          rules: 'none',
          zones: resolveEditCapability(data.zones_edit_mode, { isAdmin: false }),
        });
      })
      .catch(() => {
        if (cancelled) return;
        setPolicy(null);
        setCapability({ rules: 'none', zones: 'propose' });
      });

    return () => { cancelled = true; };
  }, [cameraId, isAdmin]);

  return { capability, policy };
};

export default useAnalyticsCapability;
